import React, { useState } from "react";
import {
  CardContent,
  Card,
  Grid,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
const MatchingSection = ({
  Rule,
  menu,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {    
    setAnchorEl(e.currentTarget);
    e.stopPropagation();
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Card
      sx={{
        borderRadius: "12px",
        "& .MuiCardContent-root:last-child": { paddingBottom: "15px" },
        
        marginBottom: "20px",
      }}
    >
      
      <CardContent
        sx={{
          padding: "15px",
        }}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Grid container 
            spacing={1} 
            justifyContent="center"
            alignItems="center">
              <Grid item>
                <SwapHorizIcon
                  style={{ width: "40px", height: "40px", color: "#8792AB" }}
                />
              </Grid>
              <Grid item>
                <Typography
                  sx={{
                    color: "#050D2E",
                    fontSize: ".875rem",
                    fontWeight: 550,
                    lineHeight: "16px",
                    marginBottom: "5px",
                  }}
                >
                {Rule.ruleName}
                </Typography>
                <Typography
                  sx={{
                    color: "#050D2E",
                    fontSize: ".813rem",
                    lineHeight: "15px",
                  }}
                >
                  {Rule?.reference}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <MoreHorizIcon
              sx={{ color: "#50566E" }}
              aria-controls="accordian-menu"
              aria-haspopup="true"
              onClick={menu?.length ? handleClick : null}
            />
            <Menu
              id="accordian-menu"
              keepMounted
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              { menu && menu.map((el) => {
                  
                  return (
                    <div key={el.id} style={{ width: "200px" }}>
                      <MenuItem
                        onClick={(e) => {
                          e.stopPropagation();
                          el.handler(Rule);
                          handleClose();
                        }}
                      >
                        {el.action}
                      </MenuItem>
                    </div>
                  );
                })}
            </Menu>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MatchingSection;
